var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"blank-modal","width":0,"height":0,"min-width":0,"min-height":0,"pivotX":0,"pivotY":0.3,"delay":100},on:{"before-close":_vm.beforeClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }